import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext } from "react";
import MediaPreview from "./components/MediaPreview";
import TextPreview from "./components/TextPreview";
import AddAssetButton from "./components/AddAssetButton";
import TiktokPrivacyLevelDropdown from "./components/TiktokPrivacyLevelDropdown";
import MoreOptions from "./components/MoreOptions";
import { PLACEMENT } from "components/ui/utils/constant";

const TiktokPreview = (post) => {

    const {
        id,
        user_id,
        user_name,
        username,
        user_image,
        created_at,
        text,
        media,
        like_count,
        comment_count,
        view_count,
        retweet_count,
        className,
        title,
        link,
        muted,
        preferences,
        assets,
        postIndex,
        isEditable,
        onAssetDelete,
        onAssetEdit,
        onAssetNew,
        onTextEdit, 
        onTitleEdit, 
        onLinkEdit, 
        onCreateNetworkPost,
        onDeleteIndexPost,
        onPreferencesEdit,
        allPosts = []
    } = post;


    const network = "tiktok";
    const { company, companySocials } = useContext(CompanyContext);
    const integration = companySocials?.filter(e => e.type == network)?.[0];

    return (<>
        <div className="flex items-stretch w-full">
            {(isEditable || !!preferences?.privacy_level) && (
                <TiktokPrivacyLevelDropdown
                    onChange={(privacy_level) => onPreferencesEdit(postIndex, { ...(preferences || {}), privacy_level: privacy_level })}
                    post={post}
                    isEditable={isEditable}
                />
            )}
            <MoreOptions
                onChange={(_preferences) => onPreferencesEdit(postIndex, _preferences)}
                post={post}
                isEditable={isEditable}
            />
        </div>
        <div className={`flex flex-col !w-auto !h-auto !p-0 !overflow-hidden aspect-[9/16] !bg-gray-800  relative -mb-2 ${className}`}>
            <MediaPreview 
                asset={assets?.[0]} 
                parentClassName="!block bg-gray-900"
                className={`object-cover aspect-[9/16] !pointer-events-auto w-full`} 
                network={network}
                isEditable={isEditable}
                onAssetDelete={() => onAssetDelete(postIndex, 0)}
                onAssetEdit={(src) => onAssetEdit(postIndex, 0, src)}
                buttonsPlacement="top-end"
                videoControls={false}
            />
            {!assets?.length && 
                <div className="absolute w-[90%] left-1/2 top-9 -translate-x-1/2 -translate-y-1/2 z-[1000]">
                    <AddAssetButton 
                        network={network}
                        onAssetNew={(asset) => onAssetNew(postIndex, asset)}
                        onAssetDelete={(assetIndex) => onAssetDelete(postIndex, assetIndex)}
                        post={post}
                        allPosts={allPosts}
                        placement={PLACEMENT.BOTTOM_CENTER}
                    />
                </div>
            }
            <div className="pointer-events-none absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-b from-transparent via-transparent to-gray-900/70 flex flex-col items-end justify-end">
                <div className="w-full flex justify-between items-center p-4 gap-4 max-h-80" >
                    <div className="flex-1 text-white font-semibold !pointer-events-auto">
                        <TextPreview 
                            text={text} 
                            network={network} 
                            isEditable={isEditable}
                            post={post}
                            onTextEdit={(value) => onTextEdit(postIndex, value)}
                            previewClassName="!text-white !font-semibold group-hover:!bg-secondary-500/20 "
                            editClassName="p-2 !bg-secondary-500 rounded-2xl max-h-80 overflow-auto"
                        />
                    </div>
                    <div className="shrink-0 rounded-full p-1.5 bg-neutral-700 shrink-0">
                        <img src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} className="rotating rounded-full w-[38px] h-[38px] drop-shadow-sm" />
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default TiktokPreview;